<template>
  <div class="c-pagination">
    <div class="c-pagination-wrap" v-if="pages > 1">
      <div class="c-pagination-item" v-for="p in pages" v-bind:class="{active : (page == p)}" v-on:click="paginationonclick(p)">
        {{ p }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
name: 'Pagination',
props: [
  'page',
  'pages'
],
methods: {
  paginationonclick: function(p){
  this.$emit('page', p);
  gtag('event', 'Kliknięcie', {
    'event_category': 'Pagination',
    'event_label': 'Przejście do następnej strony ofert',
    'value': '1'
  });
  }
}
}

</script>
<style lang="scss">
  .c-pagination{
    margin: 0 auto;
    max-width: 1177.6px;
    width: 92%;
    padding: 1rem 0 0 0;
    margin-top: 2rem;
    border-top: 1px solid #b3b3b3;
    &-wrap{
      display: flex;
      justify-content: flex-end;
    }
    &-item{
      &.active{
        background-color: #c03;
        border: 1px solid #c03;
        color: #fff;
      }
      cursor: pointer;
      padding: .5rem;
      border: 1px solid #b3b3b3;
      margin-right: .5rem;
    }
  }
</style>
